var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476",
    transform: "translate(-8960 -5134)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_232",
    "data-name": "Rectangle 232",
    width: 15,
    height: 15,
    transform: "translate(8960 5134)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M39.452,87.788a.911.911,0,0,0-.287-.7,1.019,1.019,0,0,0-.718-.3,1,1,0,0,0-.732.279l-6.859,6.309-2.243-2.372a1.015,1.015,0,0,0-.711-.318.993.993,0,0,0-.739.247.947.947,0,0,0-.075,1.378l2.954,3.125a.992.992,0,0,0,.458.273,1.065,1.065,0,0,0,1.019-.227l7.625-7.018a.933.933,0,0,0,.308-.682Z",
    transform: "translate(8934.361 5050.223)",
    fill: "#15355c"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.4fe90c9591f0d4165ef82b9ec305c2dc.svg";
export { ForwardRef as ReactComponent };